module.exports = __webpack_public_path__ + "static/media/mail.b0b8cc5c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/mail.svg
// module id = 102
// module chunks = 0